/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 静脈確保実施
 */
export type TreatmentIVAccessExecuteEnum =
  (typeof TreatmentIVAccessExecuteEnum)[keyof typeof TreatmentIVAccessExecuteEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentIVAccessExecuteEnum = {
  PERFORMED: 'PERFORMED',
  NOT_PERFORMED: 'NOT_PERFORMED',
  REMOVED_PRE_HOSPITAL: 'REMOVED_PRE_HOSPITAL',
} as const;
